import { getTripwireState } from './white_label';

const useTripwireState = () => getTripwireState();

export default useTripwireState;
